import { IconButton } from '@mui/material';
import Typography from '@mui/material/Typography';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { useNavigationCore } from '../../../../core/router/navigation';

const EditHeader = () => {
  const { goToArticles } = useNavigationCore();

  return (
    <div className="p-24 sm:p-32 w-full border-b-1 bg-white header-components">
      <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
        <div className="flex items-center">
          <IconButton
            color="secondary"
            onClick={goToArticles}
          >
            <ArrowBackOutlinedIcon className='mr-6' />
          </IconButton>
          <Typography className="text-24 md:text-32 font-extrabold tracking-tight leading-none">
            Modificar Artículo
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default EditHeader;
